import React from 'react';
import { X } from 'lucide-react';
const pains = ['You arrive at the field without knowing exactly which drill you are running today', 'Your players stop progressing because there is no clear order to the content', 'You have mixed-ability groups and no way to balance them without holding back your best players', 'A missing player or a weekend fixture breaks the continuity of your whole process', 'You cannot show your value as a coach because nothing is systematized or recorded', 'You stay up late putting something together for tomorrow when you are already exhausted'];
export function PainSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-details')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white px-5 py-14 md:py-24" data-id="element-142" data-mp="2g6wqa7ylsecf">
      <div className="max-w-4xl mx-auto" data-id="element-143" data-mp="22at0cquris5r">
        <p className="text-center text-[0.7rem] md:text-xs font-bold uppercase tracking-[0.16em] text-gray-500 mb-3" data-id="element-144" data-mp="22budr1z93qqn">
          Sound familiar?
        </p>
        <h2 className="font-display uppercase text-center text-gray-900 text-[7vw] min-[430px]:text-3xl md:text-5xl leading-[1.05] mb-9 md:mb-12" data-id="element-145" data-mp="3rlpqnm6irogl">
          If you coach rugby, you know{' '}
          <span className="text-neon-deep" data-id="element-146" data-mp="5erj2tmvyt0t">this feeling.</span>
        </h2>

        <ul className="space-y-2.5 md:space-y-3 mb-10 md:mb-12" data-id="element-147" data-mp="g7uelgwr34r">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 md:gap-4 bg-gray-50 border-l-2 border-red-400 p-4 md:p-5" data-id="element-148" data-mp="38vzvuz2rb2oo">
              <X className="text-red-500 flex-shrink-0 mt-0.5" size={18} aria-hidden="true" data-id="element-149" data-mp="33vdbprcuwrgi" />
              <p className="text-gray-800 text-sm md:text-lg leading-relaxed" data-id="element-150" data-mp="3duky141kjwfr">
                {pain}
              </p>
            </li>)}
        </ul>

        <div className="bg-ink text-center px-5 py-9 md:px-6 md:py-12" data-id="element-151" data-mp="2l6yicxf2h1cj">
          <h3 className="font-display uppercase text-white text-[6.2vw] min-[430px]:text-2xl md:text-4xl leading-tight mb-6 md:mb-8" data-id="element-152" data-mp="2l6oupghhv6a0">
            How many more sessions are you going to{' '}
            <span className="text-acid" data-id="element-153" data-mp="u12e5wrypfam">improvise?</span>
          </h3>
          <button onClick={scrollToOffer} className="w-full sm:w-auto bg-neon hover:bg-neon-light text-ink font-display uppercase text-base md:text-xl tracking-wide px-8 md:px-10 py-4 md:py-5 rounded-xl shadow-[0_5px_0_0_var(--neon-deep)] active:translate-y-[3px] active:shadow-[0_2px_0_0_var(--neon-deep)] transition-all" data-id="element-154" data-mp="yuohuzg5e8ua">
            Get Rugby 360 Now
          </button>
        </div>
      </div>
    </section>;
}